import Home from "../home/Home";
import Hire from "../hire/Hire";
import { MeetingProvider } from "../../context/MeetingContext";
import { usePreference } from "../../context/PreferenceContext";
import { useInMeetingInitialization } from "../../hooks/useInMeetingInitialization";
import { resolveMeetingMode } from "../../utils/meetingInitUtils";
import Loading from "../../components/Loading";
import AlertModal, { ALERT_VARIANT } from "../../components/alertModal/AlertModal";
import { AIMS_FLOWS, AIMS_STATUS } from "../../constants";

// In-meeting entry: runs meeting initialization, handles error states, then provides the meeting to
// the flow UI picked from the meeting mode.
const InMeeting = ({ setLastKnownContext }) => {
  const { loadPreferences } = usePreference();
  const meeting = useInMeetingInitialization({ setLastKnownContext, loadPreferences });

  const meetingMode = meeting && resolveMeetingMode({ aimsStatus: meeting.aimsStatus, aimsMessage: meeting.aimsMessage });

  return (
    <MeetingProvider value={meeting && { ...meeting, meetingMode }}>
      {!meeting ? <Loading />
        : meeting.aimsStatus === AIMS_STATUS.TIMEOUT ? <AlertModal variant={ALERT_VARIANT.AIMS_TIMEOUT} isOpen={true} />
        : meeting.aimsStatus === AIMS_STATUS.EXCEPTION ? <AlertModal variant={ALERT_VARIANT.AIMS_EXCEPTION} isOpen={true} />
        : meetingMode.aimsFlow === AIMS_FLOWS.HIRE ? <Hire />
        : <Home />}
    </MeetingProvider>
  );
};

export default InMeeting;
